const VALID_CODE = /^[A-Za-z]{3}$/;

// Never throws: falls back to INR for missing/invalid codes and to 0 for bad amounts.
export const formatCurrency = (amount, currency = 'INR', opts = {}) => {
  const code = VALID_CODE.test(currency || '') ? currency.toUpperCase() : 'INR';
  const value = Number(amount);
  const safe = Number.isFinite(value) ? value : 0;
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 0,
      maximumFractionDigits: opts.maximumFractionDigits ?? (code === 'INR' ? 0 : 2),
      ...opts,
    }).format(safe);
  } catch (e) {
    return `${code} ${safe.toLocaleString('en-IN')}`;
  }
};
